import React from "react";

// ui importing
import HomeUI from "../../../../ui/homeUI/_index";

const TaskEndSoonRPage = () => {
  return (
    <>
      <HomeUI />
    </>
  )
}

export default TaskEndSoonRPage;
